 
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import * as React from "react";
// import { HandlePlpLinkClickWithHash } from "./Coveo/Commerce/commerceHelpers";
import { MainNavigationStyles, MappedLink } from "@nishtech/Overrides/Widgets/Header/MainNavigation";
import ShopSectionComponent from "@nishtech/Components/ShopSectionComponent";
import DealsSectionComponent from "@nishtech/Components/DealsSectionComponent";
import SolutionAndServicesSectionComponent from "@nishtech/Components/SolutionAndServicesSectionComponent";
import BrandSectionComponent from "@nishtech/Components/BrandSectionComponent";
import AllCategoriesComponent from "@nishtech/Components/MegaMenu/AllCategoriesComponent";
import AllCategoriesWithWidget from "@nishtech/Components/MegaMenu/AllCategoriesWithWidget";

interface OwnProps {
    link: MappedLink;
    styles: MainNavigationStyles;
    onHandleClose: Function;
    zoneId: string;
}
export const HandlePlpLinkClickWithHash = () => {
    if(!window) {return}
    const isSearchPage = window.location.pathname.includes("/search")
    if (isSearchPage) { return }
    window.location.hash = ""
}
const HeaderMenuLinkManager: React.FC<OwnProps> = ({ link, styles, onHandleClose, zoneId }): any => {
    const HandlePlpLinkClickWithHashAndHandleClose = () => {
    if (!window) { return }

    const isSearchPage = window.location.pathname.includes("/search");
    if (isSearchPage) { return }
    if(onHandleClose)
    {
        onHandleClose?.();
    }
    window.location.hash = "";
    };
    if (link?.megaMenuName === "Shop") {
        return <ShopSectionComponent link={link} onHandleClose={onHandleClose} category={link} categoryId={link.categoryId} />;
    }
    if (link?.megaMenuName === "Brands") {
        return <BrandSectionComponent zoneId={zoneId} link={link} onHandleClose={onHandleClose} />;
    }
    if (link?.megaMenuName === "Deals") {
        return <DealsSectionComponent link={link} onHandleClose={onHandleClose} zoneId={zoneId} />;
    }
    if (link?.megaMenuName === "Solutions & Services") {
        return <SolutionAndServicesSectionComponent zoneId={zoneId} link={link} onHandleClose={onHandleClose} />;
    }
    if (link?.megaMenuType === "AllCategories") {
        return <AllCategoriesComponent link={link} zoneId={zoneId} onHandleClose={onHandleClose} category={link} categoryId={link.categoryId} />;
    }
    if (link?.megaMenuType === "AllCategoryWithWidget") {
        return <AllCategoriesWithWidget link={link} zoneId={zoneId} onHandleClose={onHandleClose} category={link} categoryId={link.categoryId} />;
    }
    // if (link?.megaMenuType === "AllCategories") {
    //     return <ShopSectionComponent link={link} onHandleClose={onHandleClose} category={link} categoryId={link.categoryId} />;
    // }
    return link?.children!.map((child: MappedLink, index: number) => (
        <GridItem
            className="mega-menu-grid-item"
            width={(12 / link.numberOfColumns!) as GridWidths}
            key={`default-mega-menu-grid-item_${index}${child.title}`}
            {...styles.megaMenuGridItem}
            as="li"
        >
            <Link className="mega-menu-heading-link" href={child.url} onClick={HandlePlpLinkClickWithHashAndHandleClose}>
                {child.title}
            </Link>
            {child.children && (
                <ul data-test-selector={`linksFor_${child.title}`}>
                    {child.children.map((grandChild: MappedLink, index: number) => (
                        <li key={`default-mega-menu-link_${index}${grandChild.title}`}>
                            <Link
                                className="mega-menu-link"
                                {...styles.megaMenuLink}
                                href={grandChild.url}
                                data-test-selector={grandChild.title}
                                onClick={HandlePlpLinkClickWithHashAndHandleClose}
                            >
                                {grandChild.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </GridItem>
    ));
};

export default HeaderMenuLinkManager;
